import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class PollResponseParsers {
  static objectParser(objectType) {
    return new ObjectParser(objectType);
  }
  static objectArrayParser(objectType) {
    return new ObjectArrayParser(objectType);
  }
  static objectMapParser(objectType) {
    return new ObjectMapParser(objectType);
  }
  static enumParser(enumType) {
    return new EnumParser(enumType);
  }
  static enumArrayParser(enumType) {
    return new EnumArrayParser(enumType);
  }
}
export class PollMessageHandlers {
  static primitiveHandler(handler) {
    return PollMessageHandlers.buildHandler(handler, null);
  }
  static objectHandler(objectType, handler) {
    return PollMessageHandlers.buildHandler(handler, PollResponseParsers.objectParser(objectType));
  }
  static objectArrayHandler(objectType, handler) {
    return PollMessageHandlers.buildHandler(handler, PollResponseParsers.objectArrayParser(objectType));
  }
  static enumHandler(enumType, handler) {
    return PollMessageHandlers.buildHandler(handler, PollResponseParsers.enumParser(enumType));
  }
  static enumArrayHandler(enumType, handler) {
    return PollMessageHandlers.buildHandler(handler, PollResponseParsers.enumArrayParser(enumType));
  }
  static objectMapHandler(objectType, handler) {
    return PollMessageHandlers.buildHandler(handler, PollResponseParsers.objectMapParser(objectType));
  }
  static buildHandler(handler, parser) {
    let messageResponseHandler = function (message) {
      handler(message);
    };
    messageResponseHandler.parse = parser ? function (messageJSON, deserializeContext) {
      return parser.parse(messageJSON, deserializeContext);
    } : function (messageJSON, deserializeContext) {
      return messageJSON;
    };
    return messageResponseHandler;
  }
}
class ObjectParser {
  constructor(objectType) {
    _defineProperty(this, "objectType", void 0);
    this.objectType = objectType;
  }
  parse(messageJSON, deserializeContext) {
    return TSOGUtils.decodeObject(messageJSON, this.objectType, deserializeContext);
  }
}
class ObjectArrayParser {
  constructor(objectType) {
    _defineProperty(this, "objectType", void 0);
    this.objectType = objectType;
  }
  parse(messageJSON, deserializeContext) {
    return TSOGUtils.decodeObjectArray(messageJSON, this.objectType, deserializeContext);
  }
}
class EnumParser {
  constructor(enumType) {
    _defineProperty(this, "enumType", void 0);
    this.enumType = enumType;
  }
  parse(messageJSON, deserializeContext) {
    return TSOGUtils.decodeEnum(messageJSON, this.enumType);
  }
}
class EnumArrayParser {
  constructor(enumType) {
    _defineProperty(this, "enumType", void 0);
    this.enumType = enumType;
  }
  parse(messageJSON, deserializeContext) {
    return TSOGUtils.decodeEnumArray(messageJSON, this.enumType);
  }
}
class ObjectMapParser {
  constructor(objectType) {
    _defineProperty(this, "objectType", void 0);
    this.objectType = objectType;
  }
  parse(messageJSON, deserializeContext) {
    return TSOGUtils.decodeObjectMap(messageJSON, this.objectType, deserializeContext);
  }
}
//# sourceMappingURL=PollResponseParser.js.map
